import { Client } from './../../../core/services/client/client.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '@core/services/client/client.service';
import { DashboardPageModel, RoleViewModel, RoleEnum } from '@core/services/role/role.model';
import { RoleService } from '@core/services/role/role.service';
import { ItemLookup, TreeItem, TreeItemLookup } from '@progress/kendo-angular-treeview';
import { inputNoWhitespaceValidator } from '@shared/directives/input-no-whitespace.directive';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'Teranet-Role',
  templateUrl: './role.component.html'
})
export class RoleComponent implements OnInit {
  dailyMonitoringKey: string = 'DNS(Daily Monitoring)';
  dailyMonitoringSourceKey: string = 'Daily Monitoring';
  public expandedKeys: any[] = [];
  public checkedKeys: any[] = [];
  public disabledKeys: any[] = [];
  public roleItems: any[];
  roleId: number = -1;
  newRole: boolean;
  public key = "id";
  roleForm: FormGroup;
  clientList: Client[] = [];
  clients: Client[];
  roleList: RoleViewModel[] = [];
  roleModel: RoleViewModel;
  errorMessages: string[] = [];
  hasError: boolean;

  constructor(private spinner: NgxSpinnerService, private toastrService: ToastrService, private activatedRoute: ActivatedRoute,
    private roleService: RoleService, private router: Router, private clientService: ClientService) {
    this.activatedRoute.queryParams.subscribe(x => {
      if (x['id']) {
        this.roleId = x['id'];
        this.newRole = false;
      }
      else {
        this.newRole = true;
      }

      this.roleForm = new FormGroup({
        'Generic Role': new FormControl('', Validators.required),
        'Client': new FormControl('', Validators.required),
        'Role Name': new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
        'Description': new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
        'User Access': new FormControl('')
      });
    });
  }

  ngOnInit(): void {

    this.getClientInfos();
    this.getGenericRoles();

    this.roleForm.valueChanges.subscribe(x => {
      this.hasError = false;
    });
  }

  getRole() {
    if (this.newRole) {
      this.roleModel = new RoleViewModel();
    }
    else {
      this.roleService.getRoleById(this.roleId).subscribe(x => {
        this.roleModel = x;
        this.bindClientInfos();
        const tempList = this.roleModel.dashboardPages.map(x => x.id);
        this.roleService.getDashboardPagesByRole(this.roleModel.genericRoleId).subscribe(x => {
          this.roleModel.dashboardPages = x as DashboardPageModel[];
          for (var i = 0; i < this.roleModel.dashboardPages.length; i++) {
            if (tempList.includes(this.roleModel.dashboardPages[i].id)) {
              this.checkedKeys.push(this.roleModel.dashboardPages[i].id);
            }
            if (this.roleModel.dashboardPages[i].parentId == 0) {
              this.roleModel.dashboardPages[i].parentId = null;
            }
          }
          this.onClientChange(false);
        });
      });
    }
  }

  getGenericRoles() {
    this.roleService.getGenericRole().subscribe(value => {
      this.roleList = value;
      this.getRole();
    });
  }

  getClientInfos() {
    this.clientService.getAllClients().subscribe(data => {
      this.clientList = data as Client[];
    });
  }

  bindClientInfos() {
    const genericRole = this.roleList.find(x => x.id == this.roleModel.genericRoleId);
    if (genericRole?.isInternal == true) {
      this.clients = this.clientList.filter(x => x.id == 0);
    }
    else if (genericRole?.isInternal == false) {
      this.clients = this.clientList.filter(x => x.id != 0);
    }
    else {
      this.clients = null;
    }
  }

  onRoleChange() {
    this.bindClientInfos();
    this.roleModel.clientInfoId = null;
    this.roleService.getDashboardPagesByRole(this.roleModel.genericRoleId).subscribe(x => {
      this.roleModel.dashboardPages = x;
      this.checkedKeys = [];
      this.disabledKeys.push(this.dailyMonitoringKey);
      for (var i = 0; i < this.roleModel.dashboardPages.length; i++) {
        this.roleModel.dashboardPages[i].isEnabled = false;
        if (this.roleModel.dashboardPages[i].parentId == 0) {
          this.checkedKeys.push(this.roleModel.dashboardPages[i].id);
          this.roleModel.dashboardPages[i].parentId = null;
        }
      }
    });
  }

  onClientChange(isClientChange) {
    let dashboardPage = this.roleModel.dashboardPages.find(x => x.displayName == this.dailyMonitoringKey);
    if (( this.roleList.find(x => x.id == this.roleModel.genericRoleId).name.toLowerCase().trim() == RoleEnum.administrator) && dashboardPage !== undefined)  {
      if (this.disabledKeys.includes(this.dailyMonitoringKey)) {
        this.disabledKeys = [];
      }
    }
    else if (dashboardPage !== undefined) {
      if (!this.disabledKeys.includes(this.dailyMonitoringKey)) {
        this.disabledKeys.push(this.dailyMonitoringKey);
        let index = this.checkedKeys.indexOf(dashboardPage.id);
        if (index != -1) {
          this.checkedKeys.splice(index, 1);
          if (isClientChange) {
            let accountIndex = this.checkedKeys.indexOf(dashboardPage.parentId);
            if (accountIndex != -1 && !this.checkedKeys.some(x => this.roleModel.dashboardPages.filter(d => d.parentId == dashboardPage.parentId && d.id != dashboardPage.id).map(x => x.id).includes(x))) {
              this.checkedKeys.splice(accountIndex, 1);
            }
          }
        }
      }
    }
  }

  onCheckedChange(itemLookup: TreeItemLookup): void {
    if (itemLookup?.parent) {
      this.checkParentElement(itemLookup.parent);
    }
    if (this.checkedKeys.length > 0) {
      this.roleForm.get('User Access').setValidators(null);
    }
    else {
      this.roleForm.get('User Access').setValidators([Validators.required]);
    }
    this.roleForm.get('User Access').updateValueAndValidity();
  }

  checkParentElement(item: ItemLookup) {
    if (this.isChildChecked(item)) {
      this.updateArray(item?.item);
    }
    if (item?.parent != null) {
      this.checkParentElement(item.parent);
    }
  }

  isChildChecked(item: ItemLookup): boolean {
    return item.children.some(x => this.checkedKeys.includes(x.dataItem.id));
  }

  updateArray(newitem: TreeItem) {
    if (!this.checkedKeys.includes(newitem.dataItem.id)) {
      this.checkedKeys.push(newitem.dataItem.id);
    }
  }

  onCancel() {
    this.router.navigateByUrl('/roles');
  }

  onSubmit() {
    this.checkFormValidationErrors();
    if (this.roleForm.valid && !this.hasError) {
      for (var i = 0; i < this.roleModel.dashboardPages.length; i++) {
        if (this.roleModel.dashboardPages[i].parentId == null) {
          this.roleModel.dashboardPages[i].parentId = 0;
        }
        if (this.checkedKeys.includes(this.roleModel.dashboardPages[i].id)) {
          this.roleModel.dashboardPages[i].isEnabled = true;
        }
        else {
          this.roleModel.dashboardPages[i].isEnabled = false;
        }
      }
      this.roleModel.dashboardPages = this.roleModel.dashboardPages.filter(x => x.isEnabled) as DashboardPageModel[];
      this.roleModel.isInternal = this.roleList.find(x => x.id == this.roleModel.genericRoleId)?.isInternal;
      if (this.newRole) {
        this.roleService.post(this.roleModel).subscribe(x => {
          if (x) {
            this.toastrService.success(this.roleModel.displayName + ' added successfully.', 'Role');
            this.router.navigateByUrl('/roles');
          }
        },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error.code, 'Role');
          });
      }
      else {
        this.roleService.put(this.roleId, this.roleModel).subscribe(x => {
          if (x) {
            this.toastrService.success(this.roleModel.displayName + ' updated successfully.', 'Role');
            this.router.navigateByUrl('/roles');
          }
        });
      }
    }
  }

  checkFormValidationErrors() {
    this.hasError = false;
    this.errorMessages = [];
    Object.keys(this.roleForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.roleForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          this.errorMessages.push(key);
          this.hasError = true;
        });
      }
    });
  }

}
